<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <button class="btn btn-sm btn-link" @click="$router.go(-1)">
                <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
              </button>
              <h4 class="card-title">{{ $t("message.admin.news") }}</h4>
            </div>
            <div class="card-body px-3">
              <!-- <router-link :to="{name: 'admin-index'}" class="btn btn-sm btn-outline-primary" >{{$t('message.back')}}</router-link> -->
              <!-- <br/> -->
              <b-table
                :items="news"
                :fields="news_fields"
                :per-page="per_page"
                :current-page="current_page"
              >
                <template v-slot:cell(data)="data">
                  <button
                    class="btn btn-info btn-sm"
                    @click="show_news_data(data.item)"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteNews(data.item)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </template>
              </b-table>
              <div class="d-flex justify-content-center">
                <b-pagination
                  v-model="current_page"
                  :total-rows="news_length"
                  :per-page="per_page"
                  aria-controls="my-table"
                ></b-pagination>
              </div>
              <button class="btn btn-outline-success" @click="add_news">
                Добавить
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="show_news_details"
      :title="$t('message.admin.data')"
      :hide-footer="true"
    >
      <div @paste="handlePaste">
        <div class="form-group">
          <label>{{ $t("message.admin.news_title") }}</label>
          <input type="text" class="form-control" v-model="news_single.title" />
        </div>
        <div class="form-group">
          <label>Домен</label>
          <select class="form-control" v-model="news_single.domain">
            <option value="attistrade.kz">attistrade.kz</option>
            <option value="attistrade.cn">attistrade.cn</option>
          </select>
        </div>
        <div class="form-group">
          <label>Описание</label>
          <textarea
            style="height: 200px"
            class="form-control"
            v-model="news_single.description"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Дата</label>
          <datepicker
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="news_single.date = ' '"
            @blur="
              news_single.date == ' '
                ? (news_single.date = '')
                : (news_single.date = news_single.date)
            "
            inputClass="form-control"
            v-model="news_single.date"
            placeholder="Дата"
            :inputAttr="{ id: 'contract_date' }"
          />
        </div>
        <div class="form-group">
          <label>Внешняя ссылка</label>
          <input type="text" class="form-control" v-model="news_single.url" />
        </div>
        <div class="d-flex">
          <div
            class="form-group"
            id="drop-area"
            @dragover="handleDragover"
            @paste="handlePaste"
            @drop="handleDrop"
          >
            <label>
              <input type="file" class="form-control" @change="handleFile" />
            </label>
          </div>

          <img
            :src="news_single.image"
            v-if="news_single.image !== ''"
            class="preview_image"
          />
        </div>
        <button @click="save" class="btn btn-success">
          {{ $t("message.save") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "admin-news",
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.load();
  },
  computed: {
    news_length() {
      return this.news.length;
    },
  },
  data() {
    return {
      uploadable_file_contents: "",

      json_data: "",
      per_page: 20,
      current_page: 0,
      news: [],
      news_single: {
        title: "",
        description: "",
        image: "",
        date: "",
        domain: "",
        url: "",
        file_handler: null,
      },
      news_fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "title",
          label: this.$t("message.admin.news_title"),
          sortable: true,
        },
        {
          key: "domain_name",
          label: "Домен",
          sortable: true,
        },
        {
          key: "date",
          label: this.$t("message.admin.news_date"),
          sortable: true,
        },
        {
          key: "data",
          label: this.$t("message.admin.news_actions"),
        },
      ],
    };
  },
  // mounted(){
  //     const dropArea = document.getElementById('drop-area');

  //     // dropArea.addEventListener('dragover', (event) => {
  //     //     event.stopPropagation();
  //     //     event.preventDefault();
  //     //     // Style the drag-and-drop as a "copy file" operation.
  //     //     event.dataTransfer.dropEffect = 'copy';
  //     // });

  //     // dropArea.addEventListener('drop', (event) => {
  //     //     event.stopPropagation();
  //     //     event.preventDefault();
  //     //     const fileList = event.dataTransfer.files;
  //     //     this.handleDrop(fileList)
  //     // });
  // },
  methods: {
    handlePaste(evt) {
      // console.log(event)
      const clipboardItems = evt.clipboardData.items;
      console.log(clipboardItems);
      const items = [].slice.call(clipboardItems).filter(function (item) {
        console.log(item);
        // Filter the image items only
        return item.type.indexOf("image") !== -1;
      });
      if (items.length === 0) {
        return;
      }

      const item = items[0];
      // Get the blob of image
      this.news_single.file_handler = item.getAsFile();
      const reader = new FileReader();
      reader.addEventListener("load", (event) => {
        this.news_single.image = event.target.result;
      });
      reader.readAsDataURL(this.news_single.file_handler);
    },
    deleteNews(data) {
      axios.post(window.base + "/account/NewsDelete?id=" + data.id).then(() => {
        this.load();
      });
    },
    save() {
      let fd = new FormData();
      fd.append("title", this.news_single.title);
      fd.append("description", this.news_single.description);
      fd.append("date", this.news_single.date);
      fd.append("domain_name", this.news_single.domain);
      fd.append("image", this.news_single.file_handler);
      fd.append("url", this.news_single.url);

      if (this.news_single.id && this.news_single.id !== "") {
        //update
        axios
          .post(
            window.base + "/account/NewsUpdate?id=" + this.news_single.id,
            fd,
            { headers: { "Content-Type": "multipart/form-data" } },
          )
          .then(() => {
            this.$bvModal.hide("show_news_details");
            this.load();
          });
      } else {
        //create
        axios
          .post(window.base + "/account/NewsCreate", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then(() => {
            this.$bvModal.hide("show_news_details");
            this.load();
          });
      }
    },
    handleDragover(event) {
      event.stopPropagation();
      event.preventDefault();
      // Style the drag-and-drop as a "copy file" operation.
      event.dataTransfer.dropEffect = "copy";
    },
    handleDrop(event) {
      event.stopPropagation();
      event.preventDefault();
      const fileList = event.dataTransfer.files;

      this.news_single.file_handler = fileList[0];
      const reader = new FileReader();
      reader.addEventListener("load", (event) => {
        this.news_single.image = event.target.result;
      });
      reader.readAsDataURL(fileList[0]);
    },
    handleFile(event) {
      this.news_single.file_handler = event.target.files[0];
      const reader = new FileReader();
      reader.addEventListener("load", (event) => {
        this.news_single.image = event.target.result;
      });
      reader.readAsDataURL(event.target.files[0]);
      // this.uploadable_file_contents = 'data:image/jpeg;base64,'+btoa(event.target.files[0])
    },
    /**
     * Shows modal to create a new news
     */
    add_news() {
      this.news_single = {
        title: "",
        description: "",
        image: "",
        date: "",
        domain: "",
        file_handler: null,
      };
      this.$bvModal.show("show_news_details");
    },
    /**
     * shows a modal window with detailed data
     */
    show_news_data(data) {
      this.$bvModal.show("show_news_details");
      this.news_single = data;
      this.news_single.domain = this.news_single.domain_name;
    },
    /**
     * Fetches list of all users, filters only those who is not active and
     * adds to users list
     */
    load() {
      axios.get(window.base + "/account/GetNews").then((response) => {
        this.news = response.data;
      });
    },
  },
};
</script>
<style scoped>
#drop-area {
  flex-basis: 100%;
}
#drop-area label {
  position: relative;
  border-radius: 10px;
  border: 1px dashed rgba(0, 0, 0, 0.4);
  display: block;
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s;
}
#drop-area label:after {
  content: "Изображение: Нажмите для выбора / Перетащите / Вставте из буфера";
  color: rgba(0, 0, 0, 0.4);
}
#drop-area label input {
  opacity: 0;
  position: absolute;
}
#drop-area label img {
  position: absolute;
  left: 25px;
  top: 25px;
  width: auto;
  height: 100px;
  border-radius: 5px;
}
.preview_image {
  height: 150px;
  width: auto;
  margin-left: 20px;
  border-radius: 10px;
}
</style>
